// @flow

"use strict";

/**
 * ユーザ情報
 */
export default class User {
  constructor(uuid: string){
    this.uuid = uuid;   // UUID
  }

  static create(uuid: string): User{
    return new User(uuid);
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/user.js